import React from 'react';
import { Col } from '../Grid';

import { Col as Props } from '../../types';

export const HeaderStartCell: React.FC<Props> = (props) => {
  return <Col {...props} />;
};
